import { TRACE_STORE_NAME } from '@/creditflowresearch/application/Trace/constants';
import Range from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/Range/Range';
import { useTraceFiltersContext } from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';

const RangeContainer = (props) => {
  const { filterName } = props;
  const { getFiltersByFilterName } = useFiltersContext();
  const filters = getFiltersByFilterName(TRACE_STORE_NAME, filterName);

  const { itemsFilter } = useTraceFiltersContext();
  const { range: defaultRangeValue } = itemsFilter[filterName];

  const selectedRangeValue = filters?.range || defaultRangeValue;
  const minValue = filters?.minValue || defaultRangeValue.min;
  const maxValue = filters?.maxValue || defaultRangeValue.max;

  return (
    <Range
      { ...props }
      selectedRangeValue={ selectedRangeValue }
      minValue={ minValue }
      maxValue={ maxValue }
    />
  );
};

export default RangeContainer;
